/*
  SMA — Estimated delivery window

  The dates are rendered server side by snippets/sma-delivery-estimate.liquid.
  Shopify serves product pages from a full page cache, so a visitor can be
  handed markup that was rendered on an earlier day — which would show a
  delivery window that has already started to expire.

  This script compares the day the markup was rendered with the visitor's
  current day. They almost always match, in which case it does nothing at
  all. When they differ, it recalculates the window from the visitor's
  today so the range on screen is never stale.
*/
(function () {
  var SELECTOR = '[data-sma-delivery-estimate]';
  var DAY_MS = 86400000;
  var SEPARATOR = ' – ';

  function isoDay(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return date.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
  }

  /* Matches the Liquid '%-d %b' format, e.g. "12 Aug". */
  function formatDate(date) {
    try {
      return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    } catch (e) {
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return date.getDate() + ' ' + months[date.getMonth()];
    }
  }

  function refresh(container) {
    var target = container.querySelector('[data-sma-delivery-dates]');
    if (!target) return;

    var minDays = parseInt(container.dataset.minDays, 10);
    var maxDays = parseInt(container.dataset.maxDays, 10);
    if (isNaN(minDays) || isNaN(maxDays)) return;

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    /* Server and visitor agree on the date — the rendered range is correct. */
    if (container.dataset.serverToday === isoDay(today)) return;

    var from = new Date(today.getTime() + minDays * DAY_MS);
    var to = new Date(today.getTime() + maxDays * DAY_MS);

    target.textContent = minDays === maxDays ? formatDate(to) : formatDate(from) + SEPARATOR + formatDate(to);
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.SmaDeliveryEstimate = { init: init };
})();
